import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, combineLatest, map, tap, take } from 'rxjs';
import { AuthHubService } from '../services/auth-hub.service';
import { AuthService } from '@auth0/auth0-angular';

export const appGuard: CanActivateFn = (): Observable<boolean> => {
  const authHub = inject(AuthHubService);
  const auth = inject(AuthService);
  const router = inject(Router);

  return combineLatest([
    auth.isAuthenticated$,
    auth.isLoading$,
    authHub.isAuthorized$
  ]).pipe(
    map(([isAuthenticated, isLoading, isAuthorized]) => {
      if (isLoading) {
        return false;
      }

      if (!isAuthenticated) {
        auth.loginWithRedirect();
        return false;
      }

      if (isAuthenticated && !isAuthorized) {
        return false;
      }

      return isAuthenticated && isAuthorized;
    }),
    tap(hasAccess => {
      if (!hasAccess) {
        auth.isAuthenticated$.pipe(take(1)).subscribe(isAuth => {
          if (isAuth) {
            router.navigate(['/unauthorized']);
          }
        });
      }
    }),
    take(1)
  );
};
